<ng-content select="label"></ng-content>

<!-- When there is only 1 type (no option to select) -->
<div class="single-type-description" *ngIf="documentTypes && documentTypes.length === 1">
  <span>{{ _documentTypes ? _documentTypes[0].text : '' }}</span>
</div>

<!-- When there are multiple avaiable types to select from -->
<div class="custom-select-wrapper" *ngIf="documentTypes && documentTypes.length > 1">
  <mat-form-field class="hidden-select type-ddl terra-error-style" *ngIf="documentTypes && documentTypes.length > 1">
    <mat-select [formControl]="documentTypeControl">
      <mat-option *ngFor="let docType of documentTypes" [value]="docType"> {{ docType.text }}</mat-option>
    </mat-select>
  </mat-form-field>
  <!-- Custom toggle (because the original doesn't match the design) -->
  <button type="button" (click)="dropDownToggleClick()" class="types-toggle" [ngClass]="{ 'has-error': isShowUnselectedTypeError }">
    <span>{{ documentTypeControl.value ? documentTypeControl.value.text : 'Select type' }}</span>
    <mat-icon class="notranslate" [color]="isShowUnselectedTypeError ? 'warn' : 'primary'">arrow_drop_down</mat-icon>
  </button>
</div>

<div class="type-error" *ngIf="isShowUnselectedTypeError"><span>Please select a document type</span></div>

<div class="file-selector" [ngClass]="{ 'has-error': isShowMissingFileError || isErrorSetFromOutside }">
  <!-- When empty -->
  <div class="upload-button" *ngIf="!isDocumentSelected && !showFileLoader && !readOnlyMode">
    <label>
      <span class="upload-text">{{ uploadButtonText }}</span>
      <input type="file" class="inputfile" #fileInput (change)="fileChange($event)" [accept]="getSupportedFileTypes()"/>
    </label>
  </div>
  <!-- While uploading / After finihsed uploading -->
  <div class="has-file" [ngClass]="{ finished: !showFileLoader }" *ngIf="isDocumentSelected || showFileLoader">
    <a href="{{ document.url }}" target="_blank" class="file-name-text link truncate lo_sensitive">{{ document.title }}</a>
    <button [disabled]="readOnlyMode" type="button" mat-icon-button aria-label="Delete file" (click)="clearFile()">
      <mat-icon class="notranslate">close</mat-icon>
    </button>
  </div>
  <mat-progress-bar *ngIf="showFileLoader" mode="determinate" [value]="uploadProgress" class="custom-progress-bar"></mat-progress-bar>
</div>

<p class="type-hint" *ngIf="typeHint">{{ typeHint }}</p>

<div class="missing-file-error" *ngIf="isShowMissingFileError"><span>Please upload a file</span></div>

<p class="error-message" *ngIf="showFileUploadError === true">
  <label class="has-error"> <i class="fa fa-error"></i> An error has occurred</label>
</p>
<p class="error-message" *ngIf="fileTypeNotSupported === true">
  <label class="has-error"> <i class="fa fa-error"></i> Uploaded file type is not supported</label>
</p>
<p class="error-message" *ngIf="displayVirusDetectedError === true">
  <label class="has-error"> <i class="fa fa-error"></i> Virus detected</label>
</p>
